import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { complaintService } from '../../services/complaintService';

export const useDeleteComplaint = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: id =>
      complaintService
        .deleteComplaint(id)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.complaint.list],
            });
            return { data, success: true };
          }
          throw new Error(data?.message);
        })
        .catch(e => {
          return { success: false, message: e.message };
        }),
  });
};
